export const White = "hsl(0, 0%, 100%)"
export const Black = "hsl(0, 0%, 0%)"
export const Dark_Gray = "hsl(0, 0%, 55%)"
export const Very_Dark_Gray = "hsl(0, 0%, 41%)"